module.exports = __webpack_public_path__ + "static/media/racquet.9ccb5390.svg";